import { useAtom } from "jotai";
import { useEffect } from "react";
import { addOrUpdateActiveOverlayerAtom } from "src/atoms/overlayers";
import { useLegend } from "src/hooks/useLegend";
import { CalculationResult, ResultMapType, WMSOverlayer } from "src/types";
import { Z_INDEX } from "src/config/zIndex";
import { GROUPS } from "src/config/overlayers";

interface Props {
  calculationResult: CalculationResult;
  legendPath: string;
  legendFront: any;
  legendBack: any;
}

const DEFAULT_OPACITY = 0.6;

export function CalculationResultWMSTileLayer(props: Props) {
  const { data: legend } = useLegend(props.legendPath);
  const [, addOrUpdateActiveOverlayer] = useAtom(addOrUpdateActiveOverlayerAtom);
  useEffect(() => {
    if (!legend) return;

    const layer: WMSOverlayer = {
      key: ["result-layer", props.calculationResult.geoserverLayer].join("-"),
      group: GROUPS.result,
      context: ["case-results"],
      ifdmType: props.calculationResult.ifdmType,
      translationKey: "layer.resultLayer",
      unit: legend.unit,
      legend: {
        legendType: "component",
        component: props.legendFront,
        componentBack: props.legendBack,
      },
      isActive: true,
      layerManager: { showFrontLegend: true, showBackLegend: true, showInLayerManager: false },

      // wms params
      url: "/geoserver/wms",
      layers: props.calculationResult.geoserverLayer,
      transparent: true,
      format: "image/png",
      opacity: DEFAULT_OPACITY,
      zIndex: Z_INDEX.results, // set default zIndex
      sld: `${window._env_.REACT_APP_API_SERVICE_URL}/${legend.sld}`,
      tiled: false,
    };

    addOrUpdateActiveOverlayer(layer);

    return function cleanup() {
      addOrUpdateActiveOverlayer({ ...layer, isActive: false });
    };
  }, [
    addOrUpdateActiveOverlayer,
    legend,
    props.calculationResult.geoserverLayer,
    props.calculationResult.mapTypeKey,
    props.legendBack,
    props.legendFront,
  ]);

  // render the component
  return null;
}
